export default "__VITE_ASSET__Gyu_F69u__"